// PROTOTYPE
import { Modal, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { VideoEmbedTab } from './VideoEmbedTab';
import { VideoUploadTab } from './VideoUploadTab';
import type { ToolbarVideoController, VideoTabKey } from './types';

interface VideoEditorModalProps {
  video: ToolbarVideoController;
}

export function VideoEditorModal({ video }: VideoEditorModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      destroyOnHidden
      footer={null}
      onCancel={video.closeEditor}
      open={video.isEditorVisible}
      title={t('exp_video_modal_title')}
    >
      <Tabs
        activeKey={video.activeTab}
        items={[
          {
            children: <VideoEmbedTab video={video} />,
            key: 'embed',
            label: <span data-testid="videoEmbedTab">{t('exp_video_embed_tab')}</span>,
          },
          {
            children: <VideoUploadTab video={video} />,
            key: 'upload',
            label: (
              <span data-testid="videoUploadTab">{t('exp_video_upload_tab')}</span>
            ),
          },
        ]}
        onChange={(key) => {
          video.setActiveTab(key as VideoTabKey);
        }}
      />
    </Modal>
  );
}
